import { TypeBrand } from '@app/entities/Brand';

export const pathToUpperLevel = (path: string): string => {
  const withoutTrailingSlash = path.charAt(path.length - 1) === '/' ? path.substring(0, path.lastIndexOf('/')) : path;

  return withoutTrailingSlash.substring(0, withoutTrailingSlash.lastIndexOf('/'));
};

export const pathToBrandCatalog = (type: TypeBrand, brand: string): string => {
  const prefix = 'catalog';
  let typePath: string = '';

  switch (type) {
    case TypeBrand.Tyres:
      typePath = 'tyres';
      break;
    case TypeBrand.Disks:
      typePath = 'discs';
      break;
    case TypeBrand.Akb:
      typePath = 'accumulators';
      break;
    case TypeBrand.Oils:
      typePath = 'oils';
      break;
    case TypeBrand.TruckTyres:
      typePath = 'trucktyres';
      break;
  }

  return `/${prefix}/${typePath}/${brand}/`;
};

export const truncatePathLevels = (path: string, levels: number = 1): string => {
  const level = levels <= 0 ? 1 : levels;

  let withoutTrailingSlash = path.endsWith('/') ? path.slice(0, -1) : path;

  for (let i = 0; i < level; i++) {
    const lastSlashIndex = withoutTrailingSlash.lastIndexOf('/');
    if (lastSlashIndex === -1) {
      return '';
    }
    withoutTrailingSlash = withoutTrailingSlash.substring(0, lastSlashIndex);
  }

  return withoutTrailingSlash;
};
